'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhanceObservations = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _formatValue = require('../../rules/src/preparators/formatValue');
var _constants = require('./constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/*
  options = {
    customAttributes: {
      decimals: id,
      prefscale: id,
    },
  }
*/

var parseAttributesValues = function parseAttributesValues(obs, attributes, indexedDimensions) {
  var attrValuesIndexes = obs.attrValuesIndexes,
    dimValuesIndexes = obs.dimValuesIndexes;
  return R.addIndex(R.reduce)(function (acc, valueIndex, attrIndex) {
    var attribute = R.nth(attrIndex, attributes);
    if (R.isNil(attribute) || !R.prop('series', attribute)) {
      return acc;
    }
    var _value = R.nth(valueIndex, attribute.values || []);
    var value = R.isNil(_value) ? _value : R.over(R.lensProp('display'), function () {
      var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return display && !R.includes(_value.id, _constants.REJECTED_VALUE_IDS);
    })(_value);
    if (!R.propOr(true, 'display', attribute) || !R.propOr(true, 'display', value)) {
      value = null;
    }
    var relationship = R.propOr([], 'relationship', attribute);
    var coordinates = {};
    var serieKey = R.pipe(function (dims) {
      return R.isEmpty(relationship) ? R.values(dims) : R.props(relationship, dims);
    }, R.map(function (dim) {
      var valueIndex = R.nth(dim.__index, dimValuesIndexes);
      var valueId = R.path(['values', valueIndex, 'id'], dim);
      coordinates = R.assoc(dim.id, valueId, coordinates);
      return dim.id + '=' + valueId;
    }), R.ifElse(R.isEmpty, R.always(null), R.join(':')))(indexedDimensions);
    return R.assoc(attribute.id, (0, _extends3.default)({}, R.pick(['id', 'name', 'relationship', 'display', 'combined'], attribute), {
      value: value,
      serieKey: serieKey,
      coordinates: coordinates,
      isObs: R.isEmpty(relationship)
    }), acc);
  }, {}, attrValuesIndexes);
};
var getFormatAttributesIndexes = function getFormatAttributesIndexes(attributes, customAttributes) {
  return R.addIndex(R.reduce)(function (acc, attribute, index) {
    if (R.equals(attribute.id, customAttributes.decimals)) {
      return (0, _extends3.default)({}, acc, {
        decimals: index
      });
    }
    if (R.equals(attribute.id, customAttributes.prefscale)) {
      return (0, _extends3.default)({}, acc, {
        prefscale: index
      });
    }
    return acc;
  }, {
    prefscale: null,
    decimals: null
  }, attributes);
};
var enhanceObservations = exports.enhanceObservations = function enhanceObservations() {
  var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var observations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var formatAttributesIndexes = getFormatAttributesIndexes(attributes, R.propOr({}, 'customAttributes', options));
  var indexedDimensions = R.indexBy(R.prop('id'), dimensions);
  return R.map(function (observation) {
    var dimValuesIndexes = observation.dimValuesIndexes;
    var indexedDimValIds = R.addIndex(R.reduce)(function (acc, dimension, dimensionIndex) {
      var id = dimension.id;
      var valueIndex = R.nth(dimensionIndex, dimValuesIndexes);
      var valueId = R.path(['values', Number(valueIndex), 'id'], dimension);
      return R.assoc(id, valueId, acc);
    }, {}, dimensions);
    return (0, _extends3.default)({}, observation, {
      attributes: parseAttributesValues(observation, attributes, indexedDimensions),
      formattedValue: (0, _formatValue.formatValue)(observation, formatAttributesIndexes, attributes),
      indexedDimValIds: indexedDimValIds
    });
  }, observations);
};